import { InputAdornment, makeStyles, Slider } from '@material-ui/core';
import themes from 'constants/themes';
import React, { useState, useEffect } from 'react';
import { changeMaxPrice, changeMinPrice } from 'redux/filter/filterSlice';
import { RootState, useAppDispatch, useAppSelector } from 'redux/store';
import { StandardTextField } from 'component/StandardTextField';
import { styled } from '@material-ui/styles';

const PriceSlider = styled(Slider)({
    color: themes.palette.primary.main,
    // height: 6,
    '& .MuiSlider-rail': {
        height: '6px',
        border: 'none',
        backgroundColor: themes.palette.primary.main,
    },
    '& .MuiSlider-track': {
        height: '6px',
        border: 'none',
        backgroundColor: themes.palette.primary.main,
    },
    '& .MuiSlider-thumb': {
        height: 24,
        width: 24,
        marginTop: '-9px',
        marginLeft: '-12px',
    },
    '& .MuiSlider-markLabel': {
        color: `${themes.palette.primary.main} !important `,
        opacity: 0.5,
        fontSize: '14px',
        fontFamily: 'PoppinsRegular',
        fontWeight: 600,
    },
    '& .MuiSlider-markLabel[data-index="0"]': {
        left: '30px !important',
    },
    '& .MuiSlider-markLabel[data-index="1"]': {
        left: 'calc(100% - 30px) !important',
    },
});

const FilterPriceRangeWidget = ({ setTriggerUpdateSearch }) => {
    const classes = useStyles();
    const dispatch = useAppDispatch();
    const { currentMinPrice, currentMaxPrice, styleMinPrice, styleMaxPrice } = useAppSelector(
        (state: RootState) => state.filter,
    );
    const [minPrice, setMinPrice] = useState<any>(currentMinPrice);
    const [maxPrice, setMaxPrice] = useState<any>(currentMaxPrice);
    const [slideValue, setSlideValue] = useState<number[]>([
        currentMinPrice || styleMinPrice,
        currentMaxPrice || styleMaxPrice,
    ]);
    const [slideMarks, setSlideMarks] = useState<any>([]);

    useEffect(() => {
        setSlideValue([currentMinPrice || styleMinPrice, currentMaxPrice || styleMaxPrice]);
        setSlideMarks([
            {
                value: styleMinPrice,
                label: `${styleMinPrice} SAR`,
            },
            {
                value: styleMaxPrice,
                label: `${styleMaxPrice} SAR`,
            },
        ]);
        // eslint-disable-next-line
    }, []);

    const handleChangeMin = (e) => {
        const value = e.target.value;
        setMinPrice(Number(value));
    };

    const handleChangeMax = (e) => {
        const value = e.target.value;
        setMaxPrice(Number(value));
    };

    const slideValueText = (value: number) => {
        return `${value} SAR`;
    };

    const handleChangeSlide = (event: React.ChangeEvent<{}>, newValue: number | number[]) => {
        setMinPrice(newValue[0]);
        setMaxPrice(newValue[1]);
        setSlideValue(newValue as number[]);
    };

    const handleCommitSlide = (event: React.ChangeEvent<{}>, newValue: number | number[]) => {
        setMinPrice(newValue[0]);
        setMaxPrice(newValue[1]);
        setSlideValue(newValue as number[]);
        dispatch(changeMinPrice(newValue[0]));
        dispatch(changeMaxPrice(newValue[1]));
        setTriggerUpdateSearch(true);
    };

    return (
        <>
            <div className={classes.filterMinMaxWrap}>
                <div>
                    <StandardTextField
                        type={'number'}
                        InputProps={{
                            endAdornment: (
                                <InputAdornment className={classes.adornment} position="end">
                                    SAR
                                </InputAdornment>
                            ),
                        }}
                        value={minPrice || ''}
                        label="Min"
                        onChange={handleChangeMin}
                        onBlur={() => {
                            dispatch(changeMinPrice(minPrice));
                            setTriggerUpdateSearch(true);
                        }}
                    />
                </div>
                <div style={{ marginLeft: 16 }}>
                    <StandardTextField
                        type={'number'}
                        InputProps={{
                            endAdornment: (
                                <InputAdornment className={classes.adornment} position="end">
                                    SAR
                                </InputAdornment>
                            ),
                        }}
                        value={maxPrice || ''}
                        label="Max"
                        onChange={handleChangeMax}
                        onBlur={() => {
                            dispatch(changeMaxPrice(maxPrice));
                            setTriggerUpdateSearch(true);
                        }}
                    />
                </div>
            </div>
            <div className={classes.filterMinMaxWrap} style={{ padding: '15px 15px' }}>
                <PriceSlider
                    getAriaLabel={() => 'Price range'}
                    value={slideValue}
                    min={styleMinPrice}
                    max={styleMaxPrice}
                    marks={slideMarks}
                    onChange={handleChangeSlide}
                    onChangeCommitted={handleCommitSlide}
                    valueLabelDisplay="off"
                    getAriaValueText={slideValueText}
                />
            </div>
        </>
    );
};

export default FilterPriceRangeWidget;

const useStyles = makeStyles(() => ({
    sortWrap: {
        marginTop: 20,
    },
    filterTitle: {
        marginTop: 24,
        fontSize: 18,
        fontWeight: 600,
        color: themes.palette.primary.main,
    },
    filterMinMaxWrap: {
        display: 'flex',
        alignItems: 'center',
    },
    adornment: {
        '& > p': {
            fontFamily: 'PoppinsRegular',
            fontStyle: 'normal',
            fontWeight: 600,
            fontSize: 16,
            color: themes.palette.primary.main,
            opacity: 0.5,
        },
    },
}));
